import { Container } from '@volkswagen-onehub/components-core';
import React from 'react';
import { HuchaVentaValues } from '../../../../shared/models/hucha-values';
import { HuchaStandardButtons } from '../../ui/hucha-venta-standard-buttons';

export const HuchaStandardCardC3 = ({ huchaValues }: { huchaValues: HuchaVentaValues }) => {
	return (
		<Container stretchContent data-testid="c3-container">
			<HuchaStandardButtons huchaValues={huchaValues} />
		</Container>
	);
};
